import { ACCOUNT_ID, DIMENSION } from 'hooks';
import { REPORT_SCHEDULE_ROUTE } from 'modules/scheduled-reports/config';
import { saveDynamicReport } from 'modules/scheduled-reports/flows/saveDynamicReport';
import { dynamicReportsNameValidations } from 'modules/scheduled-reports/validations/dynamicReportNameValidations';
import { FORM_MODES } from '../../../../../../../config/formModes';
import { DYNAMIC_REPORT_MODE } from '../../../../../../scheduled-reports/hooks/dynamicReportModeParam';
import { urlDateParser, urlDateSerialize } from '../../../../../../taboola-common-frontend-modules/utils/urlUtils';
import ActionableTextWithInternalLinkCellRenderer from '../../../components/CellRenderers/ActionableTextWithInternalLinkCellRenderer';
import { DynamicReportsActionsCellRenderer } from '../../../components/CellRenderers/DynamicReportsActionsCellRenderer';
import { DATE_PRESET, END_DATE, REPORT_ID, START_DATE } from '../../../hooks';
import { normalizeColumnDefs } from '../../../utils';
import {
    actionsColumnType,
    alwaysVisibleColumnType,
    editableColumn,
    leftPinnedColumn,
    rightPinnedColumn,
    staticColumn,
} from '../../columns';
import * as FIELDS from '../../fields';
import { defaultHeaderComponentParams } from '../../fields';
import { onlyNetworkColumn } from '../../predicates';
import { DYNAMIC_REPORTS_REPORT_ID } from './dynamicReportsReportId';

const dynamicReportsColumnDefinitions = [
    {
        headerName: FIELDS.DYNAMIC_REPORT_ACCOUNT_NAME.label,
        field: FIELDS.DYNAMIC_REPORT_ACCOUNT_NAME.field,
        visibilityCondition: onlyNetworkColumn,
    },
    {
        headerName: FIELDS.DYNAMIC_REPORT_NAME.label,
        field: FIELDS.DYNAMIC_REPORT_NAME.field,
        type: [leftPinnedColumn, alwaysVisibleColumnType, editableColumn],
        cellRenderer: ActionableTextWithInternalLinkCellRenderer,
        cellRendererParams: {
            lines: 2,
            to: REPORT_SCHEDULE_ROUTE,
            paramsToKeep: [ACCOUNT_ID, DIMENSION, START_DATE, END_DATE, DATE_PRESET],
            paramsFactory: ({ id, dateRange, startDate, endDate }) => ({
                [REPORT_ID]: id,
                [DATE_PRESET]: dateRange,
                [START_DATE]: startDate && urlDateSerialize(urlDateParser(startDate)),
                [END_DATE]: endDate && urlDateSerialize(urlDateParser(endDate)),
                [DYNAMIC_REPORT_MODE]: FORM_MODES.EDIT,
            }),
        },
        cellEditor: FIELDS.DYNAMIC_REPORT_NAME.cellEditor,
        cellEditorParams: {
            validations: dynamicReportsNameValidations,
        },
        valueChangeHandler: (newValueData, { id }, _, __, ___, context) =>
            saveDynamicReport({
                accountId: context.accountNumericId,
                accountName: context.accountName,
                reportId: id,
                dynamicReport: newValueData,
            }),
    },
    {
        headerName: FIELDS.DYNAMIC_REPORT_DATE_RANGE.label,
        field: FIELDS.DYNAMIC_REPORT_DATE_RANGE.field,
        cellRenderer: FIELDS.DYNAMIC_REPORT_DATE_RANGE.cellRenderer,
        cellRendererParams: { msgIdPrefix: 'app.campaigns.campaign.date.range' },
        headerComponentParams: defaultHeaderComponentParams,
    },
    {
        headerName: FIELDS.LAST_MODIFY_ON_UPDATE_TIME.label,
        field: FIELDS.LAST_MODIFY_ON_UPDATE_TIME.field,
        valueFormatter: FIELDS.LAST_MODIFY_ON_UPDATE_TIME.valueFormatter,
    },
    {
        headerName: FIELDS.UPDATED_BY.label,
        field: FIELDS.UPDATED_BY.field,
    },
    {
        headerName: FIELDS.ACTIONS_COLUMN.label,
        field: FIELDS.ACTIONS_COLUMN.field,
        valueGetter: params => params.data,
        type: [rightPinnedColumn, actionsColumnType, staticColumn],
        cellRenderer: DynamicReportsActionsCellRenderer,
        csv: false,
        minWidth: 85,
        maxWidth: 85,
        width: 85,
    },
];

export const columnDefinitions = normalizeColumnDefs(dynamicReportsColumnDefinitions, DYNAMIC_REPORTS_REPORT_ID);
